import React from 'react';
import icon from './icon-home.svg';
import { Link } from 'react-router-dom';
import withSounds from '../../containers/withSounds';
import packageJson from '../../../package.json';

const {
  REACT_APP_JENKINS_BUILD_TAG,
  REACT_APP_JENKINS_BUILD_URL,
  REACT_APP_JENKINS_GIT_COMMIT,
  REACT_APP_JENKINS_BUILD_TIME_Chicago,
  REACT_APP_JENKINS_BUILD_TIME_UTC
} = process.env;

const versionInfoMap = {
  Version: packageJson.version,
  'Build Tag': REACT_APP_JENKINS_BUILD_TAG,
  'Build Url': REACT_APP_JENKINS_BUILD_URL,
  'Git Commit': REACT_APP_JENKINS_GIT_COMMIT,
  'Build Time (Chicago)': REACT_APP_JENKINS_BUILD_TIME_Chicago,
  'Build Time (UTC)': REACT_APP_JENKINS_BUILD_TIME_UTC
};

let versionInfo = '';

Object.keys(versionInfoMap).forEach(label => {
  if (versionInfoMap[label]) {
    versionInfo += `${label}: ${versionInfoMap[label]}\n`;
  }
});

if (versionInfo.length > 0) {
  versionInfo = `Current Build Info\n\n${versionInfo}`;
}

function HomeIcon({ user }) {
  return (
    <div className="icon">
      <div className="home">
        <Link to="/" title={user && user.isAdmin ? versionInfo : ''}>
          <img src={icon} alt="Home" />
        </Link>
      </div>
    </div>
  );
}

export default withSounds({ mouseEnterSound: true })(HomeIcon);



// WEBPACK FOOTER //
// ./src/components/HomeIcon/index.js